module.exports = { "default": require("core-js/library/fn/number/is-finite"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/number/is-finite.js
// module id = 576
// module chunks = 0